import { Button, Checkbox, Card, Typography, Row, Col } from 'antd';
import React, { useState } from 'react';
import { ErrorConnectionFailed, SendToBackend } from './HelperContactBackend';
import './Stepper.css';
import Pdf from './documents/consent-form-public.pdf';

const { Title, Text } = Typography;

export const FormConsent = ({ next, prev, platform, setPlatform, sessionId }) => {

    const [nConsent, setNConsent] = useState(0);

    var platformName = '';

    switch (platform) {
        case "tiktok":
            platformName = "TikTok";
            break;
        case "youtube":
            platformName = "YouTube";
            break;
        case "instagram":
            platformName = "Instagram";
            break;
    }

    const checkBoxes = [
        {
            key: "18",
            text: "I am 18 years of age or older"
        },
        {
            key: "read",
            text: "I have read this consent form in its entirety or had it read to me"
        },
        {
            key: "voluntary",
            text: "I voluntarily consent to participate in this research"
        },
        {
            key: "use",
            text: "I have used " + (platformName) + " for a time period of 3 months or more"
        }
    ];

    // Expects an array
    const onChange = (checkedValues) => {
        setNConsent(checkedValues.length);
    };

    const onNext = () => {
        var consentData = JSON.stringify({
            "session_id": sessionId.session_id,
            "consented_for": {"declarations": checkBoxes}
        });
        SendToBackend(consentData,
                      'consents/',
                      next,
                      ErrorConnectionFailed);
    }

    function ConsentFormItem({ title, text }) {
        return (
            <Card title={title} key={title} className="Text">
                {text}
            </Card>
        );
    };

    function ConsentCheckBox({ text }) {
        return (
            <Row className="TopMargin">
                <Col>
                    <Checkbox
                        key={text}
                        value={text}
                        className="ConsentText"
                    >
                        {text}
                    </Checkbox>
                </Col>
            </Row>
        );
    }

    return (
        <div align="center">
            <Title >
                Please review the consent form and confirm the following statements
            </Title>
            
            <a href = {Pdf} target = "_blank">Download the full consent form in pdf format</a>

            <Checkbox.Group style={{ width: '100%' }} onChange={onChange}>
                {checkBoxes.map((item) => (
                    <ConsentCheckBox {...item} />
                ))}
            </Checkbox.Group>

            <Button
                className="RightMargin"
                onClick={() => {prev();
                                setPlatform(null);}}>
                Previous
            </Button>
            <Button
                type="primary"
                disabled={!(nConsent === checkBoxes.length)}
                onClick={onNext}>
                Next
            </Button>
        </div>
    )
};

export default FormConsent;